import React from 'react';
import FontAwesome from 'react-fontawesome';

import BrandsInfoItem from 'components/pages/brand/BrandsInfoItem';

import NewsFeedItem from 'components/global/application/NewsFeedItem';
import OffscreenSlider from 'components/global/application/OffscreenSlider';
import VideoFeed from 'components/global/application/video/VideoFeed';
import { BREAK_POINT } from 'constants/responsive';
import Carousel from 'containers/global/application/Carousel';
import { ArticlesApi, HeroSlidesApi, NodeApi } from 'providers/api';
import Log from 'providers/log';
import FeaturedItem from './FeaturedItem';
import InstrumentSlide from './InstrumentSlide';
import SlideShowSlide from './SlideShowSlide';

import { Article, ArticleResponseData } from 'types/drupal/ArticleNode';
import { BrandsInfoModel } from 'types/drupal/BrandInfo';
import FeaturedResponseData from 'types/drupal/FeaturedResponseData';
import { HeroSlide } from 'types/drupal/HeroSlideNode';
import { InstrumentGroup } from 'types/drupal/InstrumentGroupNode';
import { InventoryInstrument } from 'types/drupal/InstrumentNode';

import { Helmet } from 'react-helmet';

import './Home.sass';

import InstrumentSvgMap from 'components/global/application/svg_components';

import synchronyLogo from 'assets/images/synchrony-logo.jpg';

interface State {
    featuredLoaded: boolean;
    // tslint:disable-next-line:prefer-array-literal    literal causes ambiguity/syntax issues
    featured: Array<Article | InventoryInstrument | InstrumentGroup>;
    articlesLoaded: boolean;
    articles: Article[];
    heroSlidesLoaded: boolean;
    heroSlides: HeroSlide[];
}
export interface StateProps {
    brands: BrandsInfoModel[];
    fetchFailed: boolean;
    isMobile: boolean;
}
type CombinedProps = StateProps & DispatchProps;

export interface DispatchProps {
    loadBrandsInfo(): void;
}

class Home extends React.Component<CombinedProps, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            articles: null,
            articlesLoaded: false,
            featured: null,
            featuredLoaded: false,
            heroSlides: null,
            heroSlidesLoaded: false
        };
    }

    public componentDidMount() {
        this.props.loadBrandsInfo();

        NodeApi.getFeatured().then((data: FeaturedResponseData) => {
            this.setState({
                featured: data.data,
                featuredLoaded: true
            });
        }).catch(reason => Log.error(reason));
        ArticlesApi.getArticles().then((data: ArticleResponseData) => {
            this.setState({
                articles: data.data,
                articlesLoaded: true
            });
        });
        HeroSlidesApi.getSlides().then((data: HeroSlide[]) => {
            this.setState({
                heroSlides: data,
                heroSlidesLoaded: true
            });
        });
    }

    public helmet() {
        return (
            <Helmet>
                <meta name="title" content="Vintage Guitars - Fine Fretted Instruments Since 1970 | Gruhn Guitars" />
                <meta name="description" content="The world's original vintage guitar store located in Nashville, TN.  Buy your next guitar, get an expert appraisal, or repair your vintage instrument." />
                <title>Vintage Guitars - Fine Fretted Instruments Since 1970 | Gruhn Guitars</title>
            </Helmet>
        );
    }

    public render() {
        return window.innerWidth < BREAK_POINT ? this.mobile() : this.desktop();
    }

    public mobile() {
        const article = this.state.articlesLoaded ? this.state.articles[0] : null;
        const { featured } = this.state;
        return (
            <div className="Home-container-mobile">
                {this.helmet()}
                <div className="row Slideshow">
                    {!this.state.heroSlidesLoaded
                    ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" style={{ color: 'white' }} spin />)
                    : (<Carousel name="Home-carousel" >
                        {this.state.heroSlides.map((val, index) => {
                            return (
                            <SlideShowSlide
                                key={index}
                                title={val.title}
                                description={val.field_description.value}
                                img={val.field_image.file.url}
                                url={'/' + val.field_associated_content.alias}
                                theme={val.field_hero_theme.value}
                            />);
                        })}
                    </Carousel>)
                    }
                </div>
                <div className="row InstrumentTypes">
                    <OffscreenSlider height={100} slideDelta={90}>
                        {InstrumentSvgMap.map((val, index) => (<InstrumentSlide key={index} svgComponent={val.value} type={val.key} url={val.url} />))}
                    </OffscreenSlider>
                </div>
                {
                   this.renderBrands()
                }
                <div className="row">
                    <span className="text-center Featured-header">Featured</span>
                </div>
                <div className="Featured">
                    {!this.state.featuredLoaded
                    ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
                    : featured.slice(0, 6).map(val => (<FeaturedItem key={val.nid} content={val} />)
                    ).reduce((prev: JSX.Element[][], cur: JSX.Element, index: number) => {
                        if (index % 3 === 0) prev.push(Array());
                        prev[prev.length - 1].push(cur);
                        return prev;
                    },       []).map((subElms: JSX.Element[]) => {
                        return  (
                            <div className="row FeaturedRow" key={subElms.map(cur => cur.key).join()}>
                            {subElms}
                            </div>);
                    })}
                </div>
                <div className="row">
                    <span className="text-center News-header">News</span>
                </div>
                <div className="row News">
                    {!this.state.articlesLoaded
                        ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
                        : (<NewsFeedItem
                                key={article.nid}
                                className="News-item"
                                description={article.title}
                                imgUrl={article.field_image.file.url}
                                url={'/' + article.alias}
                        />)
                    }
                    <span className="text-center See-more-link"><a href="/news">See More</a></span>
                </div>
                <div className="row">
                    <span className="text-center Videos-header">Videos</span>
                </div>
                <div className="row Videos">
                    <VideoFeed playlistId="PLI5S23KbdHdXRl1to7-blr5JWGTVqBN9T" displayNum={1} />
                    <span className="text-center See-more-link"><a href="/videos">See More</a></span>
                </div>
                <div className="row Connect">
                    <span className="Header">Connect with Us</span>
                    <span className="Hashtag">#gruhnguitars</span>
                    <span className="Icons-container">
                        <a target="_blank" href="https://www.facebook.com/gruhnguitars"><FontAwesome className="Home-connect-icon" name="facebook-square" /></a>
                        <a target="_blank" href="https://www.instagram.com/gruhnguitars/"><FontAwesome className="Home-connect-icon" name="instagram" /></a>
                        <a target="_blank" href="https://twitter.com/gruhnguitars"><FontAwesome className="Home-connect-icon" name="twitter-square" /></a>
                        <a target="_blank" href="https://www.youtube.com/user/gruhnguitarsinc"><FontAwesome className="Home-connect-icon" name="youtube-play" /></a>
                    </span>
                </div>
                <div className="row">
                    <div className="col-12">
                    <p style={{ margin: 'auto', width: '50%', textAlign: 'center', fontSize: 16, fontWeight: 500 }} className="Header">Visit our Financing Partners</p>
                        <div className="row" style={{ marginBottom: 15 }}>
                            <div style={{ margin: 'auto', width: '50%' }}>
                                <a style={{ marginTop: '25px' }} className="affirm-site-modal" data-page-type="homepage">
                                    <img src="https://cdn-assets.affirm.com/images/all_black_logo-transparent_bg.png" style={{ display: 'block', margin: 'auto', width: '100%' }}/>
                                </a>
                            </div>
                        </div>
                        <div className="row">
                            <div style={{ margin: 'auto', width: '50%' }}>
                                <form style={{ width: '100%' }}name="eTailAppForm" action=" https://etail.mysynchrony.com/eapply/eapply.action " method="post">
                                    <input type="hidden" name="mid" value="5348121040116715" />
                                    <input type="hidden" name="pcgc" value="GA/14" />
                                    <input type="image" className="img-responsive" src={synchronyLogo} width="100%" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public desktopHeroSlide() {
        if (!this.state.heroSlidesLoaded) {
            return (<FontAwesome className="loading-spinner" name="spinner" size="3x" style={{ color: 'white' }} spin />);
        }

        return (
            <Carousel name="Home-carousel" >
                {this.state.heroSlides.map((val, index) => {
                    return (
                        <SlideShowSlide
                            key={index}
                            title={val.title}
                            description={val.field_description.value}
                            img={val.field_image.file.url}
                            url={'/' + val.field_associated_content.alias}
                            theme={val.field_hero_theme.value}
                        />);
                })}
            </Carousel>
        );
    }

    public desktop() {
        const { featured } = this.state;
        return (
            <div className="Home-container">
                {this.helmet()}
                  <div className="row Slideshow">
                    {this.desktopHeroSlide()}
                  </div>
                <div className="row InstrumentTypes">
                    <div className="offset-1 col-10 InstrumentTypes-col">
                        {InstrumentSvgMap.map((val, index) => (<InstrumentSlide key={index} svgComponent={val.value} type={val.key} url={val.url} />))}
                    </div>
                </div>
                {
                   this.renderBrands()
                }
                <div className="row Featured">
                    <div className="offset-1 col-10 Featured-header">Featured</div>
                         {!this.state.featuredLoaded
                        ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
                        : featured.slice(0, 12).map(val => (<FeaturedItem key={val.nid} content={val} />)
                        ).reduce((prev: JSX.Element[][], cur: JSX.Element, index: number) => {
                            if (index % 12 === 0) prev.push(Array());
                            prev[prev.length - 1].push(cur);
                            return prev;
                        },       []).map((subElms: JSX.Element[]) => {
                            return  (
                                <div className="offset-1 col-10 row FeaturedRow" key={subElms.map(cur => cur.key).join()}>
                                {subElms}
                                </div>);
                        })}
                </div>
                <div className="row Feeds">
                    <div className="offset-1 col-4">
                        <div className="News">
                            <div className="row">
                                <span className="News-header">News Feed</span>
                            </div>
                            <div className="row News-content">
                                {!this.state.articlesLoaded
                                ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
                                : this.state.articles.slice(0, 3).map((article: Article) => {
                                    return <NewsFeedItem
                                        key={article.nid}
                                        className="News-item"
                                        description={article.title}
                                        imgUrl={article.field_image.file.url}
                                        url={'/' + article.alias}
                                    />;
                                })}
                                <span className="text-center See-more-link"><a href="/news">See More</a></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="Videos">
                            <div className="row">
                                <span className="Videos-header">Video Feed</span>
                            </div>
                            <div className="row Videos-content">
                                <VideoFeed itemClassName="Video-item" playlistId="PLI5S23KbdHdXRl1to7-blr5JWGTVqBN9T" displayNum={3} />
                                <span className="text-center See-more-link"><a href="/videos">See More</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 Connect">
                        <span className="Header">Connect with Us</span>
                        <span className="Hashtag">#gruhnguitars</span>
                        <span className="Icons-container">
                            <a target="_blank" href="https://www.facebook.com/gruhnguitars"><FontAwesome className="Home-connect-icon" name="facebook-square" /></a>
                            <a target="_blank" href="https://www.instagram.com/gruhnguitars/"><FontAwesome className="Home-connect-icon" name="instagram" /></a>
                            <a target="_blank" href="https://twitter.com/gruhnguitars"><FontAwesome className="Home-connect-icon" name="twitter-square" /></a>
                            <a target="_blank" href="https://www.youtube.com/user/gruhnguitarsinc"><FontAwesome className="Home-connect-icon" name="youtube-play" /></a>
                        </span>
                    </div>
                    <div className="col-6 Connect">
                    <p style={{ margin: 'auto', width: '85%', textAlign: 'center' }} className="Header">Visit our Financing Partners</p>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <a style={{ marginTop: '25px' }} className="affirm-site-modal" data-page-type="homepage">
                                    <img src="https://cdn-assets.affirm.com/images/all_black_logo-transparent_bg.png" style={{ display: 'block', margin: 'auto', width: '75%' }}/>
                                </a>
                            </div>
                            <div className="col-12 col-md-6">
                                <form style={{ width: '100%' }}name="eTailAppForm" action=" https://etail.mysynchrony.com/eapply/eapply.action " method="post">
                                    <input type="hidden" name="mid" value="5348121040116715" />
                                    <input type="hidden" name="pcgc" value="GA14" />
                                    <input type="image" style={{ width: '75%', marginTop: '10%' }} src={synchronyLogo} />
                                    <input type="hidden" value="Apply"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public renderBrands() {
        if (this.props.brands && this.props.brands.length <= 0) {
            return (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />);
        }

        const col = this.props.isMobile ? 'col-6' : 'col-2';

        return(
            <div className="brandsContainer text-center">
                <div className="row justify-content-center">
                    {
                        this.props.brands.map((brand, key) => {

                            const offset_desktop = key === 0 ? 'offset-1' : 'offset-0';
                            const offset = this.props.isMobile ? 'offset-0' : offset_desktop;

                            return (
                                <BrandsInfoItem
                                    isMobile={this.props.isMobile}
                                    item={brand}
                                    className={`${col} ${offset}`}
                                    key={key}
                                    showAsClickableImage={true}
                                />
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/home/Home.tsx